
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-4a58c152\",\"scoped\":true,\"hasInlineConfig\":true}!sass-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Profile.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Profile.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4a58c152\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Profile.vue"),
  /* scopeId */
  "data-v-4a58c152",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./client/views/profiles/Profile.vue
// module id = 106
// module chunks = 42